export const purchasingTabs = [
  { to: '/purchasing/review', id: 'review' as const, label: 'Review' },
  { to: '/purchasing/products', id: 'products' as const, label: 'Products' },
  { to: '/purchasing/vendor-items', id: 'vendor-items' as const, label: 'Vendor items' },
  { to: '/purchasing/settings', id: 'settings' as const, label: 'Settings' },
] as const

export type PurchasingTabId = (typeof purchasingTabs)[number]['id']

export function tabFromPath(pathname: string): PurchasingTabId | null {
  if (pathname.startsWith('/purchasing/settings')) return 'settings'
  if (pathname.startsWith('/purchasing/products')) return 'products'
  if (pathname.startsWith('/purchasing/vendor-items')) return 'vendor-items'
  if (pathname.startsWith('/purchasing/review')) return 'review'
  return null
}
